// New addresses (domeinApp.nl.ts). English counterpart.
export const appDomeinEn = {
    company: {
        title: 'Company details',
        kvk: 'Chamber of Commerce (KvK) {kvk}',
        contact: 'Contact',
        where: 'The app lives at {app} and the board on the wall at {board}. Only sign in at {app}.',
    },
    /** Oude beginscherm-app van f.amumin.com: weg, en {app} opnieuw op het beginscherm. */
    homeScreen: 'Did you have AMUMIN on your Home Screen? Remove the old icon and add {app} to your Home Screen again. On an iPhone or iPad, notifications only work from the Home Screen.',
    push: {
        title: 'Notifications are off in this browser',
        body: 'AMUMIN now lives at amumin.app. Notifications are switched on per address, so this browser needs to do it once more. Do you want notifications here again?',
        action: 'Turn on notifications',
        later: 'Not now',
        done: 'Notifications are on again.',
        denied: 'This browser blocks notifications. You can allow them in your browser settings.',
    },
};
//# sourceMappingURL=domeinApp.en.js.map